import {
  FETCH_COLLECTION_REQUEST,
  FETCH_COLLECTION_SUCCESS,
  FETCH_COLLECTION_FAILURE,
} from '../actions';

const defaultCollectionsState = {
  collections: [],
  loading: false,
  error: false
};

const reducer = (state = defaultCollectionsState, action) => {
  switch(action.type){
    case FETCH_COLLECTION_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_COLLECTION_SUCCESS:
      const collections = state.collections.filter(c => c.id !== action.collection.id)
      collections.unshift(action.collection);

      return {
        ...state,
        collections,
        loading: false,
      };
    case FETCH_COLLECTION_FAILURE:
      return {
        ...state,
        loading: false,
        error: true
      };
    default:
      return state;
  }
}

export default reducer;
